import type { FC, ReactElement } from 'react';

import { useGiftCardData } from '@/modules/perseo-billing/hooks/use-gift-card-data';

import { AddGiftCard } from './add-gift-card';
import { AppliedGiftCard } from './applied-gift-card';

export const GiftCardView: FC = (): ReactElement => {
  const { cartHasGiftCardPayment } = useGiftCardData();
  const hasGiftcard = cartHasGiftCardPayment();

  if (hasGiftcard) {
    return <AppliedGiftCard />;
  }
  return <AddGiftCard />;
};
